import React from "react";

export const FooterImage = ({ value, invoiceLogoStyle }) => { 
  if (!value) return null;

  if (invoiceLogoStyle?.display === 'none') return null

  let logoStyle = { maxHeight: 200, maxWidth: '100%', width: '100%' }

  if (invoiceLogoStyle?.height) {
    logoStyle.height = invoiceLogoStyle?.height
  }

  return (
    <div className="invoice-footer" style={{ position: 'absolute', bottom: 0, left: 0, right: 0, width: '100%', }}>
      {value && (
        <div className={``}>
          <img style={{ ...logoStyle, }} src={value} alt="logo" />
        </div>
      )}
    </div>
  );
};

export default FooterImage;
